/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamExamlangidImportExamItem202,
  PostApiV1ExamExamlangidImportExamItem400,
  PostApiV1ExamExamlangidImportExamItem401,
  PostApiV1ExamExamlangidImportExamItem404,
  PostApiV1ExamExamlangidImportExamItem500,
  PostApiV1ExamExamlangidImportExamItemMutationRequest,
  PostApiV1ExamExamlangidImportExamItemMutationResponse,
  PostApiV1ExamExamlangidImportExamItemPathParams,
} from "../../types/examEvaluationController/PostApiV1ExamExamlangidImportExamItem.ts";
import { importExamItemViewModelSchema } from "../importExamItemViewModelSchema.ts";

export const postApiV1ExamExamlangidImportExamItemPathParamsSchema = z.object({
  examLangId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ExamExamlangidImportExamItemPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamExamlangidImportExamItem202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamlangidImportExamItem202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamExamlangidImportExamItem400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamlangidImportExamItem400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamExamlangidImportExamItem401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamlangidImportExamItem401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamExamlangidImportExamItem404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamlangidImportExamItem404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamExamlangidImportExamItem500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamlangidImportExamItem500>;

export const postApiV1ExamExamlangidImportExamItemMutationRequestSchema =
  z.lazy(
    () => importExamItemViewModelSchema,
  ) as unknown as ToZod<PostApiV1ExamExamlangidImportExamItemMutationRequest>;

export const postApiV1ExamExamlangidImportExamItemMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamExamlangidImportExamItem202Schema,
  ) as unknown as ToZod<PostApiV1ExamExamlangidImportExamItemMutationResponse>;
